module.exports = __webpack_public_path__ + "static/media/icon-xls.22a8e28d.svg";